export default __webpack_public_path__ + "static/media/subscription.d38ba2a4.svg";